import React from 'react' 
import Navbar from '../components/Navbar';
import swal from 'sweetalert'
import firebase from 'firebase'
import FormUser from '../components/FormUser'

class Login extends React.Component {
  state = {
    email: '',
    password: ''
  }

  changeState = e => {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  login = () => {
    firebase.auth().signInWithEmailAndPassword(this.state.email, this.state.password)
      .then(() => {
        this.props.history.push('/')
      })
      .catch(err => {
        let errCode = err.code
        let errMessage = err.message
        console.log(errCode)
        if (errCode === 'auth/weak-password') {
          swal("Validation Error", "Password too weak!", "error")
        } else  if (errCode === 'auth/invalid-email'){
          swal("Validation Error", 'Wrong email format!', "error")
        } else if (errCode === 'auth/user-not-found') {
          swal("Error", 'User not found!', "error")
        } else {
          swal("Error", errMessage, "error")
        }
      })
  }

  render() {
    return (
      <React.Fragment>
          <Navbar/>
          <FormUser {...this.props} action={this.login} changeState={this.changeState} title="Sign In" buttonName="Sign In"/>
      </React.Fragment>
    )
  }
}

export default Login
